import React from 'react';
import ClientLink from './ClientLink.mjs';

const MenuHamburguer = ({ isOpen, toggleMenu }) => {
    // Função para fechar o menu ao clicar em um link
    const handleCloseMenu = () => {
        if (isOpen) {
            toggleMenu();
        }
    };

    return (
        <div style={{
            position: 'absolute',
            top: '50px',
            left: 0,
            width: '100%',
            backgroundColor: '#6e3bc2',
            color: '#f0ebf8',
            padding: '20px',
            display: isOpen ? 'block' : 'none' // Exibe ou esconde o menu baseado no estado isOpen
        }}>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '10px' }}><ClientLink to="/lancamentos" style={{ color: '#f0ebf8', textDecoration: 'none' }} onClick={handleCloseMenu}>Lançamentos</ClientLink></li>
                <li style={{ marginBottom: '10px' }}><ClientLink to="/plataformas" style={{ color: '#f0ebf8', textDecoration: 'none' }} onClick={handleCloseMenu}>Plataformas</ClientLink></li>
                {/* <li style={{ marginBottom: '10px' }}><ClientLink to="/dicas" style={{ color: '#f0ebf8', textDecoration: 'none' }} onClick={handleCloseMenu}>Dicas</ClientLink></li>
                <li style={{ marginBottom: '10px' }}><ClientLink to="/brechas" style={{ color: '#f0ebf8', textDecoration: 'none' }} onClick={handleCloseMenu}>Brechas</ClientLink></li> */}
                <li style={{ marginBottom: '10px' }}><ClientLink to="/grupo" style={{ color: '#f0ebf8', textDecoration: 'none' }} onClick={handleCloseMenu}>Personalização</ClientLink></li>
                {/* <li><ClientLink to="/" style={{ color: '#f0ebf8', textDecoration: 'none' }} onClick={handleCloseMenu}>Sair</ClientLink></li> */}
            </ul>
        </div>
    );
};

export default MenuHamburguer;
